"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Contains default values for the `reactOptions` object.
 */

exports.defaultReactOptions = {
  useCamelCaseFlagKeys: true
};